import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule,FormsModule  } from '@angular/forms';
import { TranslateModule, TranslateStore } from '@ngx-translate/core';
import { EwCommonModule, EwMaterialComponentsModule } from 'ew-common-lib';
import { EwMaTableListComponent } from './ew-ma-table-list.component';
import { EwMaTableListService } from './ew-ma-table-list.service';
import { WebinarListingLibComponent } from './components/webinar-listing-lib/webinar-listing-lib.component';
import { SelectSessionComponent } from './select-session/select-session.component';
import { EventRuningComponent } from './event-runing/event-runing.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AttendeeListComponent } from './components/attendee-list/attendee-list.component';
import { WebinarAnalyticsComponent } from './components/webinar-analytics/webinar-analytics.component';
import { EwTranslateService } from './services/ew-translate.service';
import { HighchartsChartModule } from 'highcharts-angular';
import { WorldMapComponent } from './components/webinar-analytics/world-map/world-map.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SatDatepickerModule  } from 'saturn-datepicker-ext';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RouterModule } from '@angular/router';
export const translateModule = TranslateModule.forChild();


@NgModule({
  declarations: [
    EwMaTableListComponent,
    WebinarListingLibComponent,
    SelectSessionComponent,
    EventRuningComponent,
    DeleteConfirmationComponent,
    AttendeeListComponent,
    WebinarAnalyticsComponent,
    WorldMapComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule ,
    EwCommonModule,
    EwMaterialComponentsModule,
    translateModule,    
    NgxPaginationModule,
    HighchartsChartModule,
    NgxMatSelectSearchModule,
    SatDatepickerModule,     
    InfiniteScrollModule
  ],
  providers: [TranslateStore,EwTranslateService],
  exports: [
    EwMaTableListComponent,
    WebinarListingLibComponent,
    SelectSessionComponent,
    EventRuningComponent,
    DeleteConfirmationComponent,
    AttendeeListComponent,
    WebinarAnalyticsComponent,
  ]
})
export class EwMaTableListModule {
  /**
   * @description
   * EwMaTableListModule
   * @param environment Local or Prod
   * @returns EwMaTableListModule module
   */
  public static forRoot(environment: any): ModuleWithProviders<EwMaTableListModule> {
    return {
      ngModule: EwMaTableListModule,
      providers: [
        EwMaTableListService,
        {
          provide: 'env', // you can also use InjectionToken
          useValue: environment,
        }        
      ],
    };
  }
}
